export const FILE_TYPES = {
  PDF: 'application/pdf',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLS: 'application/vnd.ms-excel',
  CSV: 'text/csv',
  JPEG: 'image/jpeg',
  GIF: 'image/gif',
  JPG: 'image/jpg',
  SVG: 'image/svg+xml',
  PNG: 'image/png',
};

export const IMAGE_TYPES = [
  'png',
  'jpeg',
  'jpg',
  'gif',
  'svg',
];

export const IMAGE_FILE_TYPES = [FILE_TYPES.JPEG, FILE_TYPES.JPG, FILE_TYPES.SVG, FILE_TYPES.PNG, FILE_TYPES.GIF];

export const HEADER_HEIGHT_OFFSET = 60;
export const NAVBAR_WIDTH_OFFSET = 55;
export const ATTACHMENT_DETAILS_SECTION_OFFSET = 461;
